import envConstants from "./envConstants";

export const customClientBApiRoutePath = "pepsi";
export const customClientBId = "9e951c04-edad-42a7-af77-accaf41701a1";
export const customClientBName = "pepsi";
export const customClientBHostnamePattern = "pepsico";

export const findCustomClientBByHostname = (hostname: string) => {
  if (hostname.includes(customClientBHostnamePattern)) {
    return { warehouseApiUrl: envConstants.CUSTOMCLIENTB_WAREHOUSE_API };
  }
  return undefined;
};
